import { isProduction } from '../constants/config';

/**
 * Logger that only outputs in development and staging - silent in production.
 * Use for debugging, analytics initialization, connection tests, etc.
 */
const shouldOutput = () => !isProduction();

export const logger = {
  log: (...args: unknown[]) => {
    if (shouldOutput()) {
      console.log(...args);
    }
  },
  info: (...args: unknown[]) => {
    if (shouldOutput()) {
      console.info(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (shouldOutput()) {
      console.warn(...args);
    }
  },
  debug: (...args: unknown[]) => {
    if (shouldOutput()) {
      console.debug(...args);
    }
  },
  error: (...args: unknown[]) => {
    if (shouldOutput()) {
      console.error(...args);
    }
  },
};
